import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseInventoryHeaderSearch = () => {
  const warehouseInventoryHeaderSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/inventory-header/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { warehouseInventoryHeaderSearch }
}

export default InteractorWarehouseInventoryHeaderSearch
